<div class="start-page-result-container">
  <div class="search-section-header mb-4 ml-1">
    <span class="search-section-title text-base font-semibold">{{ 'start-page.search.start-page-section' | translate }}</span>
  </div>
  <ul>
    @for (app of searchResults.startPage; track app.appId) {
      @if (app.isBookmark) {
        <li class="application-container">
          <bookmark-search-result
            (click)="logBookmarkResult(app)" 
            [bookmark]="app"
          />
        </li>
      } 
      @else {
        <li class="application-container">
          <application-search-result
            (isClicked)="logAppSearchResult(app)"
            [app]="app"
          />
        </li>
      }
    }
  </ul>
</div>
